import { css, cx } from "@emotion/css";
import { Button } from "react-aria-components";

import { Icon } from "../../../../foundations/icons/Icon/Icon";

import { useDatePickerStyles } from "../utils";

interface DatePickerToggleProps {
  isDisabled?: boolean;
  isStatic?: boolean;
}

export function DatePickerToggle(props: DatePickerToggleProps) {
  const { isDisabled, isStatic } = props;
  const styles = useDatePickerStyles();

  return isStatic ? (
    <Icon color="icon-weak" name="calendar_month" />
  ) : (
    <Button
      data-testid="calendar-toggle"
      className={cx(
        styles.toggle,
        css({
          cursor: isDisabled ? "not-allowed" : "pointer",
        })
      )}
    >
      <Icon color="icon-weak" name="calendar_month" />
    </Button>
  );
}
